/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import datetime from 'node-datetime';
import Cookie from 'js-cookie';
import { addCommasToMoney } from '../../helper/index';

/**
 * @class UserInvestmentCard
 */
class UserOnTrackInvestmentCard extends Component {
  onClickUserInvest = () => {
    const {
      amount,
      status,
      title,
      maturityDate,
      tenorInDays,
      dateCreated,
      investmentId,
      actionType
    } = this.props;
    const investObj = {
      amount,
      status,
      title,
      maturityDate,
      tenorInDays,
      dateCreated,
      investmentId,
      actionType
    };
    Cookie.set('investObj', investObj);
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      amount,
      status,
      title,
      maturityDate,
    } = this.props;

    const mainAmount = addCommasToMoney(amount);
    
    return (
      <div className="savings_plan_for_interest_options ontrack">
        <a href="/withdraw-invest"
          style={{ textDecoration: 'none' }}
          onClick={this.onClickUserInvest}
        >
          <div className="header">
            <h5>
              {
                title === 'fixTip' ? 'Fixed Term Investment Portfolio' : ''
                }
            </h5>
          </div>
          <div className="savings_breakdown_interest">

            <div>
              <span>
                Amount
              </span>
              <p>
                {`₦${mainAmount}`}
              </p>
            </div>
            <div>
              <span>
                    Status
              </span>
              <p>
                {status}
              </p>
            </div>
            <div>
              <span>
                Maturity Date
              </span>
              <p>
                { datetime.create(maturityDate).format('m/d/y') }
              </p>
            </div>
          </div>
          <div className="savings_interest_progress">
            <div className="savings_progresss_text" />
            <div className="progress">
              <div className="progress-bar" style={{ width: '70%' }} />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

UserOnTrackInvestmentCard.propTypes = {
  amount: PropTypes.string,
  title: PropTypes.string,
  status: PropTypes.string,
  maturityDate: PropTypes.any,
  tenorInDays: PropTypes.any,
  dateCreated: PropTypes.any,
  investmentId: PropTypes.any,
  actionType: PropTypes.any,
};

export default UserOnTrackInvestmentCard;
